export enum WaitlistStatus {
    WAITING = 'waiting',
    NOTIFIED = 'notified',
    ACCEPTED = 'accepted',
    EXPIRED = 'expired',
    CANCELLED = 'cancelled',
}

export const WaitlistStatusLabels: Record<WaitlistStatus, string> = {
    [WaitlistStatus.WAITING]: 'Aguardando',
    [WaitlistStatus.NOTIFIED]: 'Notificado',
    [WaitlistStatus.ACCEPTED]: 'Aceito',
    [WaitlistStatus.EXPIRED]: 'Expirado',
    [WaitlistStatus.CANCELLED]: 'Cancelado',
};

export const WaitlistStatusTones: Record<WaitlistStatus, string> = {
    [WaitlistStatus.WAITING]: 'orange',
    [WaitlistStatus.NOTIFIED]: 'blue',
    [WaitlistStatus.ACCEPTED]: 'green',
    [WaitlistStatus.EXPIRED]: 'gray',
    [WaitlistStatus.CANCELLED]: 'gray',
};

export const minutesToTime = (minutes?: number) => {
    if (typeof minutes !== 'number') return '--:--';
    const hours = Math.floor(minutes / 60)
        .toString()
        .padStart(2, '0');
    const mins = (minutes % 60).toString().padStart(2, '0');
    return `${hours}:${mins}`;
};

export const getWaitlistServiceLabel = (entry: any) => {
    const main = entry?.servico?.name || 'Serviço';
    const extras = (Array.isArray(entry?.servicosExtras) ? entry.servicosExtras : [])
        .map((extra: any) => extra?.name)
        .filter(Boolean);
    const fallbackCount = !extras.length && Array.isArray(entry?.servicosExtrasIds) ? entry.servicosExtrasIds.length : 0;

    if (extras.length) return `${main} + ${extras.join(', ')}`;
    return fallbackCount ? `${main} + ${fallbackCount} ${fallbackCount === 1 ? 'extra' : 'extras'}` : main;
};
